import { useGetAppDataPermissionsStatusSuspenseQuery } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { useApp } from '../../contexts/AppContext';
export function useShowDataPermissions(hasDataPermissions) {
  const {
    appId
  } = useApp();
  const skip = hasDataPermissions !== undefined;
  const {
    data
  } = useGetAppDataPermissionsStatusSuspenseQuery({
    variables: {
      appId
    },
    skip
  });
  return skip ? hasDataPermissions : data === null || data === void 0 ? void 0 : data.hasDataPermissions;
}